import { Base } from "../../framework/base";
import { IdTitleNode } from "../common/idTitleNode";
import { RecordFurtherEducationNode } from "../recordFurtherEducation/recordFurtherEducationNode";
var RecordFurtherEducationGroupNode = /** @class */ (function () {
    function RecordFurtherEducationGroupNode(obj) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.requiredQualificationCount = obj && obj.requiredQualificationCount || 0;
        this.children = Base.getTypedArray(obj ? obj.children : null, RecordFurtherEducationNode);
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            child.parent = this;
        }
        this.collapsed = obj && obj.collapsed || false;
    }
    RecordFurtherEducationGroupNode.prototype.getRecordFurtherEducationById = function (id) {
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            if (id !== child.id)
                continue;
            return child;
        }
        return null;
    };
    RecordFurtherEducationGroupNode.getRecordFurtherEducationById = function (items, id) {
        if (!items || items.length < 1)
            return null;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var result = item.getRecordFurtherEducationById(id);
            if (!result)
                continue;
            return result;
        }
        return null;
    };
    RecordFurtherEducationGroupNode.getRecordFurtherEducationGroupNodeById = function (items, id) {
        if (!items || items.length < 1)
            return null;
        return items.find(function (i) { return i.id === id; });
    };
    RecordFurtherEducationGroupNode.getItemById = function (items, id) {
        if (!items || items.length < 1)
            return null;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item.id === id)
                return item;
            var result = item.getRecordFurtherEducationById(id);
            if (!result)
                continue;
            return result;
        }
        return null;
    };
    RecordFurtherEducationGroupNode.getFirstRecordFurtherEducationById = function (items) {
        if (!items || items.length < 1)
            return null;
        for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
            var item = items_3[_i];
            if (!item.children.length)
                continue;
            return item.children[0];
        }
        return null;
    };
    RecordFurtherEducationGroupNode.getRecordFurtherEducationCount = function (items) {
        if (!items || items.length < 1)
            return 0;
        var result = 0;
        for (var _i = 0, items_4 = items; _i < items_4.length; _i++) {
            var item = items_4[_i];
            result = result + item.children.length;
        }
        return result;
    };
    RecordFurtherEducationGroupNode.getAsList = function (items) {
        if (!items || items.length < 1)
            return [];
        var result = [];
        for (var _i = 0, items_5 = items; _i < items_5.length; _i++) {
            var item = items_5[_i];
            result.push(item);
            result = result.concat(item.children);
        }
        return result;
    };
    RecordFurtherEducationGroupNode.equalIdsInArrays = function (a, b) {
        return Base.equalStrArrays(RecordFurtherEducationGroupNode.getAsList(a).map(function (i) { return i.id; }), RecordFurtherEducationGroupNode.getAsList(b).map(function (i) { return i.id; }));
    };
    RecordFurtherEducationGroupNode.isGroup = function (arg) {
        return arg.children !== undefined;
    };
    RecordFurtherEducationGroupNode.getFurtherEducations = function (furtherEducationGroups) {
        if (!furtherEducationGroups || furtherEducationGroups.length < 1)
            return [];
        return furtherEducationGroups.map(function (i) {
            return IdTitleNode.createIdTitleNode(i.id, i.code, i.children.map(function (j) { return IdTitleNode.createIdTitleNode(j.id, j.code, [], true, [
                { key: "scopeUnit", value: j.scopeUnit.toString(10) },
                { key: "scope", value: j.scope.toString(10) },
                { key: "validity", value: j.validity.toString(10) }
            ]); }), false);
        });
    };
    RecordFurtherEducationGroupNode.getFurtherEducationsForQualification = function (furtherEducationGroups) {
        if (!furtherEducationGroups || furtherEducationGroups.length < 1)
            return [];
        return furtherEducationGroups.map(function (i) {
            return IdTitleNode.createIdTitleNode(i.id, i.code, i.children.map(function (j) { return IdTitleNode.createIdTitleNode(j.id, j.code, [], i.requiredQualificationCount === 0, [{ key: "scopeUnit", value: j.scopeUnit.toString(10) }]); }), i.requiredQualificationCount > 0);
        });
    };
    return RecordFurtherEducationGroupNode;
}());
export { RecordFurtherEducationGroupNode };
